import React from 'react';
import { Oval } from 'react-loader-spinner';

const Loader = ({ primaryColor = '#153c4f', secondaryColor = 'white', size = 20, stroke = 7 }) => <Oval strokeWidth={stroke} strokeWidthSecondary={stroke} color={primaryColor} secondaryColor={secondaryColor} height={size} width={size} />;

export default Loader;
